module.exports = __webpack_public_path__ + "img/GZR.3b941d1e.svg";